import React from 'react';
import { Link } from 'react-router-dom';

interface FormattedContentProps {
  content: string;
  className?: string;
}

export const FormattedContent: React.FC<FormattedContentProps> = ({ content, className = "" }) => {
  if (!content) return null;

  // Regex for mentions (@handle) and hashtags (#tag)
  // Mentions: @ followed by 3-30 alphanumeric characters or underscore
  // Hashtags: # followed by alphanumeric characters or underscore
  const parts = content.split(/(@[a-zA-Z0-9_]{3,30}|#[a-zA-Z0-9_À-ÿ]+)/gi);

  return (
    <p className={className}>
      {parts.map((part, i) => {
        if (part.startsWith('@')) {
          const handle = part.substring(1).toLowerCase();
          return (
            <Link key={i} to={`/${handle}`} className="text-blue-600 font-bold hover:underline">
              {part}
            </Link>
          );
        }
        
        if (part.startsWith('#')) {
          const tag = part.substring(1).toLowerCase();
          return (
            <Link key={i} to={`/explorar?tag=${tag}`} className="text-blue-600 font-bold hover:underline">
              {part}
            </Link>
          );
        }

        return part;
      })}
    </p>
  );
};
